export const POS_PRODUCT_LOADING = 'POS_PRODUCT_LOADING';
export const POS_PRODUCTS_FULFILLED = 'POS_PRODUCTS_FULFILLED';
export const POS_PRODUCT_FULFILLED = 'POS_PRODUCT_FULFILLED';
export const POS_PRODUCT_STOCK_UPDATED = 'POS_PRODUCT_STOCK_UPDATED';

export const POS_PRODUCT_STOCK_AUDIT_FULFILLED = 'POS_PRODUCT_STOCK_AUDIT_FULFILLED';
export const POS_PRODUCT_TOTAL_SUM_FULFILLED = 'POS_PRODUCT_TOTAL_SUM_FULFILLED';
export const POS_PRODUCT_TOTAL_QTY_FULFILLED = 'POS_PRODUCT_TOTAL_QTY_FULFILLED';
